import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const WithdrawStatsCards = ({ withdrawData }) => {
    const totalRequests = withdrawData.length;
    const pendingRequests = withdrawData.filter(
        (req) => req.status === "PENDING"
    ).length;
    const completedRequests = withdrawData.filter(
        (req) => req.status === "COMPLETED"
    ).length;
    const rejectedRequests = withdrawData.filter(
        (req) => req.status === "REJECTED"
    ).length;

    const totalAmount = withdrawData.reduce(
        (sum, req) => sum + (req.amount || 0),
        0
    );
    const pendingAmount = withdrawData
        .filter((req) => req.status === "PENDING")
        .reduce((sum, req) => sum + (req.amount || 0), 0);

    const stats = [
        {
            title: "Total Requests",
            value: totalRequests,
            icon: "ni ni-money-coins ",
            color: "info",
        },
        {
            title: "Pending Requests",
            value: pendingRequests,
            icon: "ni ni-watch-time ",
            color: "warning",
        },
        {
            title: "Completed Requests",
            value: completedRequests,
            icon: "ni ni-check-bold ",
            color: "success",
        },
        {
            title: "Total Amount",
            value: `$${totalAmount.toFixed(2)}`,
            icon: "ni ni-chart-bar-32 ",
            color: "info",
        },
        {
            title: "Pending Amount",
            value: `$${pendingAmount.toFixed(2)}`,
            icon: "ni ni-spaceship ",
            color: "warning",
        },
        {
            title: "Rejected Requests",
            value: rejectedRequests,
            icon: "ni ni-fat-remove ",
            color: "danger",
        },
    ];

    return (
        <Container className="mt--7" fluid>
            <Row>
                {stats.map((stat, index) => (
                    <Col
                        lg="6"
                        xl="4"
                        key={index}
                        style={{ marginBottom: "15px" }}
                    >
                        <Card className="card-stats mb-4 mb-xl-0 ">
                            <CardBody>
                                <Row>
                                    <div className="col ">
                                        <CardTitle
                                            tag="h5"
                                            className="text-uppercase text-muted mb-0"
                                        >
                                            {stat.title}
                                        </CardTitle>
                                        <span className="h2 font-weight-bold mb-0">
                                            {stat.value}
                                        </span>
                                    </div>
                                    <Col className="col-auto">
                                        <div
                                            className={`icon icon-shape bg-${stat.color} text-white rounded-circle shadow`}
                                            style={{ zIndex: 10 }}
                                        >
                                            <i className={stat.icon} />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default WithdrawStatsCards;